module.exports = __webpack_public_path__ + "h5/img/yaopinguige@2x.82c5fac5.png";